import React, { Component } from "react";
import { IconFind } from "./icons/IconFind";
import { IconPaint } from "./icons/IconPaint";
import { IconGlobe } from "./icons/IconGlobe";
import charactersImage from "../../assets/images/characters.png";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import { Links } from "../Links";
import { AppMode } from "../../AppMode";

export interface MenuProps
{
}

interface MenuState 
{
    menuOpen: boolean;
}

export class Menu extends Component<MenuProps, MenuState>
{
    constructor(props: MenuProps)
    {
        super(props);

        this.state = {
            menuOpen: false
        };
    }

    private onToggleMenu(): void 
    {
        this.setState({
            menuOpen: !this.state.menuOpen
        });
    }

    private onMenuChanged(screen: AppScreen): void 
    {
        this.setState({
            menuOpen: false
        });

        App.I.changeScreen(screen);
    }

    public render(): JSX.Element
    {
        return (
            <div className={"menu-container" + (this.state.menuOpen ? ' is-open' : '')}>
                <div className="menu-btn-container">
                    <button className={"hamburger" + (this.state.menuOpen ? ' is-active' : '')} onClick={this.onToggleMenu.bind(this)} title="Toggle menu">
                        <div className="hamburger-box">
                            <div className="hamburger-inner"></div>
                        </div>
                    </button>
                </div>
                {
                    this.state.menuOpen ?
                        <div className="container">
                            <div className="menu-section">
                                <h4 className="menu-title text-uppercase">Games and Activities</h4>
                                <div className="menu-section-btns">
                                    {App.I.appMode === AppMode.Arrivals ?
                                        <button className="btn btn-menu with-icon" title="Holiday quiz" onClick={this.onMenuChanged.bind(this, AppScreen.Quiz)}>
                                            <IconGlobe /> <span className="ps-2 ms-1">Holiday Quiz</span>
                                        </button>
                                        :
                                        <button className="btn btn-menu with-icon" title="Holiday Quiz" onClick={this.onMenuChanged.bind(this, AppScreen.Quiz)}>
                                            <IconGlobe /> <span className="ps-2 ms-1">Holiday Quiz</span>
                                        </button>
                                    }
                                    <button className="btn btn-menu with-icon" title="Painting" onClick={this.onMenuChanged.bind(this, AppScreen.ColourMe)}>
                                        <IconPaint /> <span className="ps-2 ms-1">Painting</span>
                                    </button>
                                    <button className="btn btn-menu with-icon" title="Search and find" onClick={this.onMenuChanged.bind(this, AppScreen.SearchAndFind)}>
                                        <IconFind /> <span className="ps-2 ms-1">Search and find</span>
                                    </button>
                                </div>
                            </div>

                            <div className="menu-section menu-section-as-btn" onClick={this.onMenuChanged.bind(this, AppScreen.MeetTheCharacters)}>
                                <h4 className="menu-title text-uppercase">Meet the Characters</h4>
                                <div className="character-holder">
                                    <img src={charactersImage} alt="Characters appearing over ledge" />
                                </div>
                            </div>

                            <div className="menu-section">
                                <h4 className="menu-title text-uppercase">Parent Zone</h4>
                                <div className="menu-section-btns">
                                    {App.I.appMode === AppMode.Departures ?
                                        <button className="btn btn-menu" title="Play areas" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkPlayArea())}>Play areas</button>
                                        : null
                                    }
                                    <button className="btn btn-menu" title="Baby changing facilities" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkBabyChanging())}>Baby changing facilities</button>
                                    {App.I.appMode === AppMode.Departures ?
                                        <button className="btn btn-menu" title="Kids eat free" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkKidsEatFree())}>Kids eat free</button>
                                        : null
                                    }
                                    <button className="btn btn-menu" title="Essential shopping" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkEssentialShopping())}>Essential shopping</button>
                                    {App.I.appMode === AppMode.Arrivals ?
                                        <button className="btn btn-menu" title="Heathrow Express"
                                            onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkHeathrowExpress())}>Heathrow Express</button>
                                        : null
                                    }
                                    <button className="btn btn-menu" title="Safety tips" onClick={() => App.I.changeScreen(AppScreen.EscalatorSafety)}>Safety tips</button>
                                    <button className="btn btn-menu" title="Join our mailing list" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkMailingList())}>Join our mailing list</button>
                                </div>
                            </div>
                        </div>
                        : null
                }
            </div >
        );
    }
}